// = Libs =
import { FC, useState } from 'react';

// = Styles =
import classes from './answer.module.scss';

// = Imports =
import CustomInput, {
  InputTypeType,
} from '@/components/custom-input/custom-input';
import { QuestionModel } from '@/services/question.service';
import useDebouncedFunction from '@/helpers/debounce';
import { saveAnswer } from '@/services/report.service';
import Icon from '@/common/components/ui/icon/icon';
import { OptionModel } from '@/common/components/ui/select/select.types';
import ImportAggregate from '@/pages/poll/componens/report/answer/import-aggregate/import-aggregate';
import IconButton from '@/common/components/ui/buttons/icon-button/icon-button';

const prepareValue = (type: string, val: any) => {
  if (type === 'int') {
    return Number(val);
  }
  if (type === 'file') {
    return Number(val) === -1 ? null : Number(val);
  }
  return val;
};
const Answer: FC<{
  reportId: number;
  question: QuestionModel;
  trigger: () => any;
  disabled?: boolean;
  polls: OptionModel[];
  pollDefault?: number;
}> = (props) => {
  const {
    reportId,
    question,
    trigger,
    disabled = false,
    polls,
    pollDefault,
  } = props;

  const [value, setValue] = useState(question.answer?.value);
  const [aggregation, setAggregation] = useState(false);
  const [status, setStatus] = useState<'ok' | 'pending' | 'new' | 'empty'>(
    question.answer?.value ? 'ok' : 'new'
  );

  const handleAnswer = useDebouncedFunction((value) => {
    setStatus(value ? 'ok' : 'empty');
    !disabled &&
      saveAnswer(
        reportId,
        question.questionId,
        prepareValue(question.type, value)
      ).then(trigger);
  }, 500);

  const inputMap = {
    'radio': 'select',
    'checkbox': 'multiple-select',
    'string': 'text',
    'int': 'number',
    'file': 'file',
  };

  const statusMap = {
    'ok': <Icon type={'accept'} color={'success'} />,
    'pending': <Icon type={'accept'} color={'primary'} />,
    'new': <Icon type={'warning'} color={'warning'} />,
    'empty': <Icon type={'warning'} color={'secondary'} />,
  };
  return (
    <div>
      <p className={classes.title}>{question.title}</p>
      <div className={classes['with-status']}>
        <CustomInput
          value={value}
          inputType={inputMap[question.type] as InputTypeType}
          text={'Ответ'}
          formik={false}
          name={'val'}
          onChange={(nd) => {
            setValue(nd as string);
            setStatus('pending');
            handleAnswer(nd as string);
          }}
          fullWidth
          required
          config={{
            options: Object.values(question.addition?.choice || []).map(
              (value: any, index: number) => {
                return {
                  value: String(index),
                  label: String(value),
                } as OptionModel;
              }
            ),
          }}
          disabled={disabled}
        />
        {!disabled && (
          <IconButton
            iconType={'dropdown'}
            onClick={() => setAggregation(!aggregation)}
            addClass={classes['import-button']}
          />
        )}
        {statusMap[status]}
      </div>
      {aggregation && (
        <ImportAggregate
          onSuccess={(val) => {
            setValue(val);
            handleAnswer(val);
            setAggregation(false);
          }}
          polls={polls}
          defaultPollId={pollDefault}
        />
      )}
    </div>
  );
};

export default Answer;
